var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Watermark',{attrs:{"content":_vm.watermarkText,"gap":[200, 200],"z-index":9999,"font-style":{ color: 'rgba(0, 0, 0, 0.08)', fontSize: '14px' }}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }